import { Component, OnInit, Inject, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material';
import { GlobalService } from '../../../global.service';
import { Service } from '../../../services';
import { Subscription } from "rxjs";
import { LoadingScreenService } from '../../../services/loading-screen/loading-screen.service';
import { PopupOutstandingBalanceComponent } from '../../../referred/components/popup-outstanding-balance/popup-outstanding-balance.component';
import { PopupReferPaperlessComponent } from '../../../referred/components/popup-refer-paperless/popup-refer-paperless.component';
@Component({
  selector: 'app-popup-redeem',
  templateUrl: './popup-redeem.component.html',
  styleUrls: ['./popup-redeem.component.sass']
})
export class PopupRedeemComponent implements OnInit {
  public selectBan;
  public subscriber;
  public listAccountSubscriber = [];
  public num_tel;
  public AccounInfo;
  public billBalanceField;
  public lastPaymentAmountField;
  public cycleEndDateField;
  public cycleStartDateField;
  public cycleDateField;
  public accountTypeField;
  public accountSubtypeField;
  public suscriptores;
  public totalAccountList;
  public currentList;
  public campaignID = 1;
  public paperless;
  public info = [];
  public cr = '';
  loadObserver: Subscription;
  public token: string = sessionStorage.getItem("token");
  public currentBalance;
  public expiredBalance;
  public delinquent;
  @Output() updateinitializeData = new EventEmitter();

  constructor(private loadingScreenService: LoadingScreenService, public dialog: MatDialog, public matDialogRef: MatDialogRef<PopupRedeemComponent>, private services: Service, private global: GlobalService, @Inject(MAT_DIALOG_DATA) public data: any, private router: Router) {
    if (data.currentList != undefined) {
      this.currentList = data.currentList;
    }
    if (data.info != undefined) {
      this.info = data.info;
    }
    if (data.info != undefined) {
      this.info = data.info;
    }
    if (data.delinquent != undefined) {
      this.delinquent = data.delinquent;
    }
  }
  ngOnInit() {
    this.selectBan = atob(sessionStorage.getItem("selectBan"));
    this.info = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo;
    this.subscriber = this.info[0].subscriberNumberField;
    this.paperless = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.paperlessField;
    this.expiredBalance = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.billBalanceField;
    this.loadObserver = this.global.loadObserver.subscribe((value: number) => {
      this.dataLoading(value)
    });
  }
  refreshDataTo() {
    if (this.global.validateSession() === true) {
      let index = parseInt(event.target["selectedIndex"]);
      let ban = this.currentList[index].account;
      let sub = this.info[index].subscriberNumberField;
      sessionStorage.setItem("selectBan", btoa(ban));
      sessionStorage.setItem("referredtSubscriber", btoa(sub));
      this.initializeData();
    }
  }
  initializeData() {
    this.global.refreshDataTo(this.token);
  }
  close() {
    this.matDialogRef.close('cancel');
  }
  dataLoading(sw) {
    this.selectBan = atob(sessionStorage.getItem("selectBan"));
    this.info = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo;
    this.AccounInfo = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo;
    this.paperless = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.paperlessField;
    this.expiredBalance = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.billBalanceField;
    let info = JSON.parse(atob(sessionStorage.getItem("getAccountDetails")));
    if (this.global.validateIfApplicable(this.AccounInfo, this.info, info.qualification.RedeemProgram) == false) {
      this.close();
      this.router.navigate(['home']);
    }
  }
  validateData() {
    let productType = "";
    for (let i = 0; i < this.info.length; i++) {
      if (this.info[i].subscriberNumberField == this.subscriber) {
        productType = this.info[i].productTypeField;
      }
    }
    if (this.paperless === false) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.autoFocus = true;
      dialogConfig.data = { productType: productType, suscriptor: this.subscriber, origin: 'redeem' };
      const dialogRef = this.dialog.open(PopupReferPaperlessComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(value => {        
      });
      sessionStorage.setItem("referredtSubscriber", btoa(this.subscriber));
    }
    else {
      sessionStorage.setItem("referredtSubscriber", btoa(this.subscriber));
      this.loadingScreenService.startLoading();
      this.services.getMember(this.token, this.selectBan).subscribe(data => {
        if (data.hasError == false) {
          sessionStorage.setItem("memberID",data.memberID);
          this.services.getValidateReferrer(this.token, this.subscriber, this.selectBan).subscribe(data => {
            if (data.hasError == false) {
              this.currentBalance = data.Balance;
              if (this.currentBalance > 0 && this.delinquent!='N') {
                if (this.expiredBalance.search('CR') > -1) {
                  this.cr = 'CR';
                  this.expiredBalance = parseFloat(this.expiredBalance);
                }
                else {
                  this.cr = '';
                }
                this.loadingScreenService.stopLoading();
                const dialogConfig = new MatDialogConfig();
                dialogConfig.disableClose = true;
                dialogConfig.autoFocus = true;
                dialogConfig.data = { expiredBalance: this.expiredBalance, currentBalance: this.currentBalance, cr: this.cr, origin: 'redeem' };
                const dialogRef = this.dialog.open(PopupOutstandingBalanceComponent, dialogConfig);
                dialogRef.afterClosed().subscribe(value => {
                  if (value != "cancel") {}
                });
              }
              else {
                this.matDialogRef.close();
                this.loadingScreenService.stopLoading();
                this.router.navigate(['redeem']);
              }
            }
            else {
              this.loadingScreenService.stopLoading();
              this.global.notif(data.errorDisplay);
            }
          });
        }
        else {
          this.loadingScreenService.stopLoading();
          this.global.notif(data.errorDisplay);
        }
      });
    }
    this.close();
  }
}